<template>
  <UApp :toaster="toaster" :locale="nuxtUiI18nMsg" :scroll-body="false">
    <VueLenis root :options="lenisOptions">
      <!-- cookie合规提示抽屉 -->
      <CommonDrawerCookie />
      <!-- cookie弹窗 -->
      <CommonDialogCookie />
      <!-- 首屏加载中遮罩 -->
      <!-- <CommonLoadingRainbow /> -->
      <!-- 路由切换中遮罩 -->
      <CommonLoadingRoute />
      <!-- 更新资源提示 -->
      <!-- <CommonToastUpdateSource /> -->

      <!-- 布局 -->
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </VueLenis>
  </UApp>
</template>

<script setup lang="ts">
  import { type LenisOptions } from 'lenis'

  const { t } = useI18n()
  const { configSite, configOG } = useConfigStatic()
  /** 当前语言的nuxt-ui-i18n消息 */
  const { nuxtUiI18nMsg } = useI18nInfo()
  const { formatPathDot } = useI18nTools()
  /** 格式化后的当前路由名称 */
  const curRouteName = formatPathDot()

  /** 吐司全局配置 */
  const toaster = {
    position: 'top-center' as const,
    max: 3,
    expand: false,
    portal: true,
  }

  const lenisOptions: LenisOptions = {
    smoothWheel: true,
  }

  /** 站点信息 */
  useHead({
    // 玩法文档：https://nuxt.com/docs/4.x/getting-started/seo-meta#title-template
    titleTemplate: titleLeading =>
      titleLeading ? `${titleLeading} | ${configSite.TITLE}` : configSite.TITLE,
    htmlAttrs: {},
    meta: [],
    // 替换标签页logo（覆盖默认的/favicon.ico）
    link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
  })

  /** 页面元信息 */
  useSeoMeta({
    title: () => t(`page.${curRouteName.value}.title`),
    description: () => t(`page.${curRouteName.value}.desc`),
    ogTitle: () => t(`page.${curRouteName.value}.title`),
    ogDescription: () => t(`page.${curRouteName.value}.desc`),
    ogImage: configOG.IMG,
    twitterTitle: () => t(`page.${curRouteName.value}.title`),
    twitterDescription: () => t(`page.${curRouteName.value}.desc`),
    twitterImage: configOG.IMG,
    twitterCard: configOG.TWITTER_CARD,
  })
</script>
